import { BrowserModule, Title  } from "@angular/platform-browser";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
// import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { NgModule } from "@angular/core";
import {
  FlashMessagesModule,
  FlashMessagesService
} from "angular2-flash-messages";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { HttpModule } from "@angular/http";
import { HttpClientModule } from "@angular/common/http";
import { FormsModule } from "@angular/forms";

import { AppMaterialModule } from "./app-material/app-material.module";

import "materialize-css";
import { MaterializeModule } from "angular2-materialize";
import { FroalaEditorModule, FroalaViewModule } from "angular-froala-wysiwyg";

import { HTTP_INTERCEPTORS } from "@angular/common/http";
import { ToastrModule } from "ngx-toastr";
import { UserService } from "./_services/user.service";
import { SettingService } from "./_services/setting.service";
import { ProductService } from "./_services/product.service";
import { CommonService } from "./_services/common.service";
import { SearchService } from "./_services/search.service";
import { AuthGuard } from "./_guards/auth.guard";
import { AuthInterceptor } from "./_guards/auth.interceptor";
import { APP_INITIALIZER } from "@angular/core";
import { CommonProjectDataService } from './_services/common-project-data.service';
import { MntMasterModule } from "./mnt-master/mnt-master.module";
import { Auth0Service } from "./_services/auth0.service";
import { CartService } from "./_services/cart.service";
import { TutorialService } from "./_services/tutorial.service";
// import { AppConfig } from "./app.config";

import "hammerjs";



// export function initializeApp(appConfig: AppConfig) {
//   return () => appConfig.load();
// }


@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    HttpModule,
    HttpClientModule,
    FormsModule,
    FlashMessagesModule,
    AppRoutingModule,
    MaterializeModule,
    FroalaEditorModule,
    FroalaViewModule,
    AppMaterialModule ,
    MntMasterModule   
  ],
  providers: [
    Title,
    UserService,
    SettingService,
    FlashMessagesService,
    ProductService,
    CommonService, 
    SearchService,
    CommonProjectDataService,   
    AuthGuard,
    Auth0Service,
    CartService,
    TutorialService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true
    },
    // AppConfig,
    // {
    //   provide: APP_INITIALIZER,
    //   useFactory: initializeApp,
    //   deps: [AppConfig],
    //   multi: true
    // }
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/app.module.ts